import { render, staticRenderFns } from "./InfraInquiry.vue?vue&type=template&id=62b21d8f&scoped=true&"
import script from "./InfraInquiry.vue?vue&type=script&lang=js&"
export * from "./InfraInquiry.vue?vue&type=script&lang=js&"
import style0 from "./InfraInquiry.vue?vue&type=style&index=0&id=62b21d8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b21d8f",
  null
  
)

export default component.exports